import {QueryClient, QueryClientProvider} from "react-query";
import Box from "@mui/material/Box";

import React from "react";
import UnavailabilityPage from "./UnavailabilityPage";

export function DashboardOverviewUnavailabilityPage(){
    const queryClient = new QueryClient();

    return(
        <QueryClientProvider client={queryClient}>
            <Box sx={{
                marginTop: 1,
                marginRight: 3
            }}>
                <UnavailabilityPage />
            </Box>
        </QueryClientProvider>
    );
}